var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SharePreferences from './share-preferences';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment SharePreferences on Property {\n    listing {\n      suitableApplicants\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing;
  return {
    suitability: listing.suitableApplicants
  };
};
var SharePreferencesGraphQL = _ref2 => {
  var property = _ref2.property;
  return ___EmotionJSX(SharePreferences, graphQLToProps(property));
};
SharePreferencesGraphQL.fragment = fragment;
SharePreferencesGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      suitableApplicants: PropTypes.arrayOf(PropTypes.string)
    })
  })
};
SharePreferencesGraphQL.defaultProps = {
  property: {}
};
export default SharePreferencesGraphQL;